import styled, {css} from 'styled-components';
import { theme } from '../../theme/GlobalTheme';

export const Container = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${theme.spacing.sm} ${theme.spacing.xl};
  background-color: ${theme.colors.white};
  box-shadow: ${theme.shadows.light};
  position: relative;
  width: 100%;
  min-height: 60px;
`;

export const CatfLogo = styled.img`
  width: 140px;
  height: auto;
  margin-left: ${theme.spacing.xl};
  transition: transform 0.2s ease-in-out;
  
  &:hover {
    transform: scale(1.05);
  }
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
`;

export const NavSection = styled.div`
  display: flex;
  align-items: center;
`;

export const Nav = styled.nav`
  display: flex;
  gap: ${theme.spacing.lg};
  align-items: center;
`;

const baseNavItemStyle = css`
  text-decoration: none;
  color: ${theme.colors.primary};
  font-weight: ${theme.typography.fontWeight.bold};
  font-size: 18px;
  font-family: ${theme.typography.fontFamily};
  transition: color 0.2s ease-in-out;
  
  &:hover {
    color: ${theme.colors.secondary};
  }
`;

export const NavItem = styled.a`
  ${baseNavItemStyle}
`;

export const NavButton = styled.button`
  ${baseNavItemStyle};
  background: none;
  border: none;
  cursor: pointer;
  
  &:hover {
    color: ${theme.colors.secondary};
  }
`;

export const CatfItem = styled.a`
  ${baseNavItemStyle};
  color: ${theme.colors.primary};
  margin: 0 ${theme.spacing.lg};
  
  &:hover {
    color: ${theme.colors.secondary};
  }
`;
